import {
  AssistantInfo,
  AssistantList,
  AssistantValue,
} from "../../services/api/instances/assistantsApi/types";
import { StorageObject } from "../../services/api/instances/storageApi/types/object_types";

export function extractAllAssistants(
  storageObjects: StorageObject<AssistantValue>[],
): AssistantList {
  const assistants: AssistantInfo[] = [];

  function traverse(nodes: StorageObject<AssistantValue>[]): void {
    for (const node of nodes) {
      if (node.value?.assistant_object) {
        assistants.push(node.value.assistant_object);
      }

      if (node.children && node.children.length > 0) {
        traverse(node.children);
      }
    }
  }

  traverse(storageObjects);
  return { object: "list", data: assistants };
}
